import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [showHairstudio, setShowHairstudio] = useState(false);

  useEffect(() => {
    // Tampilkan "HAIRSTUDIO" setelah 0.5 detik
    const hairstudioTimer = setTimeout(() => {
      setShowHairstudio(true);
    }, 1500);

    // Tutup splash screen setelah 2 detik
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 3000);

    // Bersihkan timer
    return () => {
      clearTimeout(hairstudioTimer);
      clearTimeout(timer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-50 flex items-center justify-center 
        bg-[#D2A679] transition-all duration-1000 
        ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}
        overflow-hidden`}
    >
      <div 
        className={`text-center transform transition-all duration-1000 
          ${isVisible 
            ? 'scale-100 opacity-100' 
            : 'scale-75 opacity-0'}`}
      >
        <div 
          className="text-white font-bold text-5xl md:text-6xl lg:text-7xl 
          tracking-wider mb-4 transform transition-all duration-1000
          animate-pulse"
        >
          PAPAKILO
        </div>
        {showHairstudio && (
          <div 
            className="text-white text-2xl md:text-3xl lg:text-4xl 
            tracking-widest transition-all duration-1000
            animate-bounce"
          >
            HAIRSTUDIO
          </div>
        )}
      </div>

      {/* Animated Overlay */}
      <div 
        className="absolute inset-0 bg-black opacity-0 pointer-events-none 
        transition-all duration-1000 animate-ping"
        style={{
          animationDuration: '2s',
          animationDelay: '0.5s',
          animationIterationCount: 1
        }}
      ></div>
    </div>
  );
};

export default SplashScreen;